<div class="mock-data-notice" role="status">
  <i class="pi pi-exclamation-triangle"></i>
  <span class="mock-data-notice__text">
    This module currently displays sample data for demonstration and is not yet connected to live data sources.
  </span>
</div>